import { SupportFormTextareaField } from './SupportFormTextareaField';

export const DescriptionField = () => {
  return (
    <SupportFormTextareaField
      name="description"
      label="Description"
      textareaProps={{
        isRequired: true,
      }}
    />
  );
};
